import React from 'react';
import { FaIndustry, FaBolt, FaBoxes, FaFire, FaTools, FaTags } from 'react-icons/fa';
import './Directions.css';

const items = [
  { icon: FaIndustry, title: 'АгораТех', text: 'Шкафы и корпуса из нержавейки AISI 304/316, углеродистой стали. Полный цикл производства.' },
  { icon: FaBolt, title: 'Орион', text: 'Производство электротехнических шкафов, пультов, корпусов по чертежам.' },
  { icon: FaBoxes, title: 'Комплексные поставки', text: 'Провенто, ДКС, реле, частотники, источники питания, климат-контроль, ЩМП, аксессуары.' },
  { icon: FaFire, title: 'Взрывозащита', text: 'Ex d / Ex e: оболочки, посты управления, кнопки, клеммные коробки.' },
  { icon: FaTools, title: 'Сборка щитов', text: 'Монтаж аппаратуры, DIN-реек, клемм, маркировка, пусконаладка.' },
  { icon: FaTags, title: 'OEM', text: 'Производство под брендом заказчика, любые размеры и конфигурации.' }
];

const Directions = () => (
  <section className="directions-section" id="directions">
    <div className="container-custom">
      <h2 className="directions-title">Наши направления</h2>
      <div className="directions-grid">
        {items.map(({ icon: Icon, title, text }) => (
          <div className="directions-tile" key={title}>
            <div className="directions-icon"><Icon /></div>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Directions;
